<template>
  <div>
    <div class="filter">
      位置筛选
      <ul>
        <li :class="{ level: level == 0 }" @click="changeLevel(0)">1-12</li>
        <li :class="{ level: level == 1 }" @click="changeLevel(1)">13-24</li>
        <li :class="{ level: level == 2 }" @click="changeLevel(2)">25-36</li>
        <li :class="{ level: level == 3 }" @click="changeLevel(3)">37-48</li>
        <li style="width: 110px;" @click="changAll(4)">查看全部</li>
        <li @click="exportPDF">导出</li>
        <li @click="syReport" style="width: 100px;">一键上移</li>
        <li @click="pxReport" style="width: 100px;">一键排序</li>
      </ul>
    </div>

    <div class="table">
      <el-row type="flex" align="middle" v-if="reportTable">
        <el-col :span="24">
          <table border v-for="(item, i) in reportTable" :key="i">
            <tbody>
              <tr>
                <td rowspan="9" style="width: 100px;">
                  <div class="px">
                    平行志愿{{ i + 1 + level * 12 }}
                  </div>
                  <div v-if="item.name == '暂无'">
                  </div>
                  <div v-else>
                    <div class="fc" v-if="item.tiaoji">服从调剂</div>
                    <div class="fc" v-else style="color: red">拒绝调剂</div>
                  </div>

                  <div class="del" v-if="item">
                    <el-button round size="mini" type="success" plain v-if="item.name && item.name != '暂无'"
                      @click="editCollege(item, i + level * 12)">编辑</el-button>
                  </div>

                  <div class="del" v-if="item">
                    <el-button round size="mini" type="danger" plain @click="delCollege(item, i)">删除</el-button>
                  </div>
                  <div class="huanwei" v-if="item">
                    <el-popover popper-class="popover-f" placement="bottom" trigger="hover">
                      <div class="popover-box">
                        <p class="box-title">志愿位置</p>
                        <span v-for="h in len" :key="h" class="box-item" @click="changeCollege(h - 1, i + level * 12)">
                          <span v-if="record.select_code[h - 1] != ''" class="box-item-box"
                            style="background: #fbbfbb; border: #fbbfbb;">{{ h }}</span>
                          <span v-else class="box-item-box">{{ h }}</span>
                        </span>
                      </div>
                      <el-button round size="mini" slot="reference" type="primary" plain>换位</el-button>
                    </el-popover>
                  </div>

                </td>
                <td colspan="7">
                  <p class="row" style="color:#adadad">
                    <span style="margin-right: 2px;font-size: 18px; color: black;">{{ item.name
                    }}</span>
                    <span style="font-size: 16px;margin-left: 5px;color: black;">【{{ item.group_name }}】</span>
                    <span v-if="item.school_tip">
                      {{ item.school_tip }} |
                    </span>
                    <span v-if="item.nature">{{ item.nature }} | </span>
                    <span v-if="item.school_type">{{ item.school_type }} | </span>
                    <span v-if="item.school_belong"> {{ item.school_belong }} |</span>
                    <span v-if="item.address" style=" white-space: nowrap">
                      <el-tooltip class="item" :content="item.address" placement="top-end" effect="light">
                        <span> {{ item.address }} | </span>
                      </el-tooltip>
                    </span>
                    <span v-if="item.baoyan">保研 | </span>
                    <span v-if="item.ruanke">排名：{{ item.ruanke }}</span>
                  </p>
                  <p style="color:#adadad;margin-top: 10px;font-size: 16px;  white-space: nowrap;overflow: hidden;
  text-overflow: ellipsis; ">
                    <span>院校代码：<span style="color: #000000;">{{ item.school_id }}</span></span>
                    <span style="margin-left: 15px;">招生计划： <span style="color: #000000;"> {{ item.plan_num }}</span>
                    </span>
                    <span style="margin-left: 15px;">选科要求：<span style="color: #000000;">{{ item.demand
                        }}</span></span>
                    <span style="margin-left: 15px;">录取规则：<span style="color: #000000;">{{ item.lqgz }}</span></span>
                    <span style="margin-left: 15px;" v-if="item.num">可选专业：<span style="color: #000000;">{{ item.num
                        }}</span></span>
                  </p>
                </td>
              </tr>
              <tr>
                <td rowspan="7" style="width: 90px">
                  <p>院校最低分 {{ item.c_score }}</p>
                  <p>院校最低分位次 {{ item.c_ranking }}</p>
                </td>
                <td style="width: 90px">专业序号</td>
                <td>专业代号/名称</td>
                <td style="width: 300px">专业详情</td>
                <td style="width: 90px">专业计划</td>
                <td style="width: 90px">学费标准</td>
                <td style="width: 120px;">移动</td>
              </tr>
              <tr v-for="(val, key) in record.specialty[i + level * 12]" :key="key" draggable="true"
                @dragstart="dragStarts(key)" @dragover.prevent="dragOver" @drop="drops(key, i + level * 6)">
                <td class="td-height">{{ val.specialty_id }}</td>
                <td class="td-height">{{ val.specialty_name }} </td>
                <td class="td-height">
                  <el-tooltip class="item" effect="dark" :content="val.remarks" placement="top-start">
                    <div class="remarks"> {{ val.remarks }}</div>
                  </el-tooltip>

                </td>
                <td class="td-height">{{ val.plan_num }}</td>
                <td class="td-height">{{ val.tuition }}</td>
                <td style="width: 120px;">
                  <img src="@/assets/img/move.png" alt="" style="width: 20px; vertical-align: bottom;">
                </td>
              </tr>

              <tr v-for="test in 6 - record.specialty[i + level * 12].length" :key="test + i + 'dfd'">
                <td style="height: 45px"></td>
                <td style="height: 45px"></td>
                <td style="height: 45px"></td>
                <td style="height: 45px"></td>
                <td style="height: 45px"></td>
                <td style="height: 45px"></td>
              </tr>
            </tbody>
          </table>
        </el-col>
      </el-row>
      <el-row type="flex" align="middle" v-if="!reportTable">
        <el-col :span="24">
          <div style="margin-top: 20px; text-align: center;"> 暂无志愿表，请先添加</div>
        </el-col>
      </el-row>
    </div>


    <!-- 选择专业-修改专业 -->
    <el-dialog :visible.sync="dialogVisible" class="mojarDialog" width="1400px" :show-close="false"
      :append-to-body="true" :close-on-click-modal="false" destroy-on-close>
      <div style="position: absolute;
    right: 10px;
    z-index: 999;
    top: -4px;
    font-size: 40px;
    font-weight: 100;" @click="colse()">×</div>
      <mojar-page :collegeDatas="collegeData" :rankingData="rankingData" :oldLine="oldLine" :userInfo="userInfo"
        @mojarChange="mojarChange" :record="record" v-if="dialogVisible" />
    </el-dialog>
  </div>
</template>

<script>
import mojarPage from "../../components/mojar_page/index.vue";
export default {
  props: ['batch_copy', 'rankingData', 'userInfo'],
  name: '',
  data() {
    return {
      dialogVisible: false,
      len: 48,
      collegeData: null,
      reportTable: [],
      level: 0,
      record: [],
      oldLine: []
    };
  },
  components: {
    mojarPage,
  },
  computed: {
  },
  watch: {
    batch_copy() {
      this.getReport()
      this.getOldCityScore()
    }
  },
  created() {
    this.getReport()
    this.getOldCityScore()
  },
  methods: {
    //普通类的志愿表
    getReport() {
      this.record = []
      this.reportTable = []
      this.len = 48
      let data = {
        user_id: this.$route.query.id,
        subject: this.userInfo.subject,
        new_batch: this.batch_copy,
      }
      this.$fecth.post("volunteer/getUserReport", data).then((res) => {
        if (res.data.record) {
          this.record = JSON.parse(res.data.record)
          this.reportTable = this.record.table.slice(0, 12)
        } else {
          this.reportTable = null
        }
      })
    },

    //修改学校信息
    editCollege(item, i) {
      this.collegeData = item
      console.log(item, i)
      this.dialogVisible = true
    },
    changeCollege(h, i) {
      this.record.table = this.moveElementInArray(this.record.table, i, h)
      this.record.select_code = this.moveElementInArray(this.record.select_code, i, h)
      this.record.specialty = this.moveElementInArray(this.record.specialty, i, h)
      this.updateReport(this.record)
      this.changeLevel(this.level)
    },
    mojarChange() {
      this.updateReport(this.record)
    },
    //更新志愿表
    updateReport(record) {
      this.$fecth
        .post("volunteer/updateReport", {
          user_id: this.$route.query.id,
          subject: this.userInfo.subject,
          new_batch: this.batch_copy,
          record: JSON.stringify(record)
        })
      this.record = record
      this.changeLevel(this.level)
      this.$forceUpdate
    },
    //选择数量
    changeLevel(e) {
      this.level = e
      let num = e * 12
      this.reportTable = this.record.table.slice(num, num + 12)
    },
    // 显示全部
    changAll() {
      this.level == 0
      this.reportTable = this.record.table.slice(0, 48)
    },
    dragStart(index) {
      this.draggedIndex = index;
    },
    dragOver() { }, // 阻止默认行为，允许放置元素。
    drop(index) {
      this.record.table = this.moveElementInArray(this.record.table, this.draggedIndex, index)
      this.record.select_code = this.moveElementInArray(this.record.select_code, this.draggedIndex, index)
      this.record.specialty = this.moveElementInArray(this.record.specialty, this.draggedIndex, index)
      this.updateReport(this.record)
      this.changeLevel(this.level)
      this.draggedIndex = null; // 重置拖动索引。
    },
    dragStarts(index) {

      this.draggedIndex = index;
    },
    drops(index, key) {
      const element = this.record.specialty[key].splice(this.draggedIndex, 1)[0];
      this.record.specialty[key].splice(index, 0, element);
      this.updateReport(this.record)
      this.changeLevel(this.level)
      this.draggedIndex = null; // 重置拖动索引。
    },

    //一键上移
    syReport() {
      this.$confirm('此操作确定后不可取消, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        //一键升序
        let new_record = {
          select_code: [],
          specialty: [],
          table: [],
        }
        this.record.select_code.forEach((element, key) => {
          if (element) {
            new_record.select_code.push(this.record.select_code[key])
            new_record.table.push(this.record.table[key])
            new_record.specialty.push(this.record.specialty[key])
          }
          console.log(element, key)
        });
        let lens = this.len - new_record.select_code.length

        for (let i = 0; i < lens; i++) {
          new_record.table.push({
            name: "暂无",
          });
          new_record.select_code.push('')
          new_record.specialty.push([])
        }

        this.record = new_record
        this.updateReport(this.record)
        this.changeLevel(0)
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        });
      });
    },
    //一键排序
    pxReport() {
      this.$confirm('此操作确定后不可取消, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let new_record = {
          select_code: [],
          specialty: [],
          table: [],
        }
        //把专业放到院校里
        let tableList = []
        this.record.table.forEach((element, key) => {
          if (!element.name || element.name != '暂无') {
            this.record.table[key]['specialty'] = this.record.specialty[key]
            if (!this.record.table[key]['c_score']) {
              this.record.table[key]['c_score'] = 0
            }
            tableList.push(this.record.table[key])
          }
        });
        //排序
        tableList.sort((a, b) => b['c_score'] - a['c_score']);

        tableList.forEach((element) => {
          new_record.select_code.push(element.select_code)
          new_record.table.push(element)
          new_record.specialty.push(element.specialty)
        });

        let lens = this.len - new_record.select_code.length

        for (let i = 0; i < lens; i++) {
          new_record.table.push({
            name: "暂无",
          });
          new_record.select_code.push('')
          new_record.specialty.push([])
        }

        this.record = new_record
        this.updateReport(this.record)
        this.changeLevel(0)
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        });
      });
    },
    // 根据批次往年录取分数线
    getOldCityScore() {
      this.$fecth
        .post("common/getOldLine", {
          subject: this.userInfo.subject,
          new_batch: this.batch_copy,
        })
        .then((res) => {
          console.log(res.data)
          this.oldLine = res.data
        });
    },
    //关闭选择专业
    colse() {
      this.dialogVisible = false
    },
    // 换位
    moveElementInArray(array, fromIndex, toIndex) {
      const element = array.splice(fromIndex, 1)[0];
      array.splice(toIndex, 0, element);
      return array
    },
    //删除志愿表
    delCollege(item) {
      if (item.select_code) {
        let select_code_id = this.record.select_code.indexOf(item.select_code)
        //如果这个学校填过就删除
        if (select_code_id > -1) {
          this.record.table[select_code_id] = {
            name: "暂无",
          }
          this.record.select_code[select_code_id] = ''
          this.record.specialty[select_code_id] = []
        }
        this.updateReport(this.record)
        this.changeLevel(this.level)
      }
    },

    //下载
    exportPDF() {
      this.$router.push(
        "/report?id=" +
        this.userInfo.id + '&new_batch=' + this.batch_copy
      );
    },
  },
};
</script>


<style scoped lang='less'>
.report {
  width: 1200px;
  margin: 0 auto;
  background: white;

  .score-table {
    font-size: 12px;
    color: #B5B3B3;
    border: 0;

    td {
      padding: 0;
      text-align: center;

    }
  }
}

.filter {
  padding: 0 52px;
  margin-top: 15px;
  height: 40px;

  ul {
    display: inline-block;
    list-style: none;
    position: relative;
    top: 7px;
  }

  li {
    float: left;
    width: 77px;
    text-align: center;
    margin-left: 13px;
    border: 1px solid #707070;
    border-radius: 19px;
    padding: 2px 5px;
  }

  li:hover {
    background: #459df6;
    color: white;
    border: #459df6;
  }



  .level {
    background: #459df6;
    color: white;
    border: #459df6;
  }
}

.top {
  margin-top: 20px;
  border-bottom: 4px solid #459EFF;
  height: 40px;
}

.right {
  float: right;
  height: 36px;

  ul {
    display: inline-block;
    list-style: none;
  }

  li {
    float: left;
    margin-left: 10px;
    height: 36px;
    padding: 17px;
    line-height: 3px;
    border-radius: 5px 5px 0 0;
  }

  li:hover {
    color: white;
    background: #459EFF;
    border-bottom: 1px solid #459EFF;
  }

}

.nav {
  color: white;
  background: #459EFF;
  border-bottom: 1px solid #459EFF;
}

.table {
  padding: 0 40px;
  margin: 0 auto;

  table {
    font-size: 14px;
    width: 100%;
    border-collapse: collapse;
    margin-top: 30px;
    border: 1px solid #dddddd;
    margin-bottom: 10px;

    .th {
      font-size: 16px;
      background: #f4f7fc;
      line-height: 35px;

      .name {
        font-size: 18px;
        font-weight: bold;
      }

      span {
        margin-right: 15px;
      }

      .col {
        margin-left: 0;
        color: #459df6;
      }
    }

    .th,
    td {
      line-height: 35px;
      padding: 5px 13px;
    }

    .td-height {
      .remarks {
        max-height: 40px;
        overflow: hidden;
      }
    }
  }

  .del {
    text-align: center;
    margin-bottom: 10px;
  }

  .huanwei {
    text-align: center;
    margin-bottom: 10px;
  }
}


.tab {
  margin-top: 0px !important;
  margin-bottom: 0px !important;
}





.px {
  margin-top: 20px;
  text-align: center;
  font-size: 14;
  margin-bottom: 10px;
}

.fc {
  text-align: center;
  color: #459df6;
  margin-bottom: 10px;
}
</style>


<style lang="less">
.mojarDialog {
  .el-dialog__header {
    padding: 0;
  }

  .el-dialog__body {
    padding: 0;
  }
}
</style>